export enum EnumStatusComanda {
  ABERTA = 'Aberta',
  Fechada = 'Fechada',
  EmFechamento = 'EmFechamento',
  Cancelada = 'Cancelada'
}
